
namespace Gordic.Epk.WebControls.Vyrizeni {

    export class VyberCertifikatu {

        constructor(signer: Gordic.Epk.WebControls.GEpkSigner) {

            if (signer == null) {
                var message = "Signer is undefined.";
                console.error(message);
                throw message;
            }
            this.signer = signer;
        }

        private signer: Gordic.Epk.WebControls.GEpkSigner;

        /** 
         * výběr a kontrola certifikátu
         */
        public select(ixsDpo: string) {
            return this.selectWflCertificate(ixsDpo)
                .then((certInfo) => {
                    return this.checkCert(certInfo);
                })
        }

        public checkNeedsToWaitForConfirmation(certInfo: Gordic.Wfl.Interface.CertInfo) {
            var needsToWaitForConfirmation = false;
            if (certInfo != null && certInfo.certMoreInfo != null && certInfo.certMoreInfo.NeedsToWaitForConfirmation != null)
                needsToWaitForConfirmation = certInfo.certMoreInfo.NeedsToWaitForConfirmation;
            return needsToWaitForConfirmation;
        }

        /**
         * výběr certifikátu s pinem
         *          */
        private selectWflCertificate(ixsDpo) {
            var dfd = $.Deferred();
            this.signer.selectCertificateWithPin({}, { cardView: true, ixsDpo: ixsDpo, forceShowCertDialog: true })
                .then((dto: Gordic.Wfl.Interface.CertInfo) => {
                    dfd.resolve(dto);
                }, (reason: IGReasonResponse) => {
                    reason.operation = "cert";
                    dfd.reject(reason);
                });
            return dfd.promise();
        }

        /**
         * kontrola otisku certifikátu
         */
        private checkCert(certInfo?: Gordic.Wfl.Interface.CertInfo) {
            return this.checkWflCertificate(certInfo);
        }

        private checkWflCertificate(certInfo?: Gordic.Wfl.Interface.CertInfo) {
            var dfd = $.Deferred();
            if (certInfo != null && certInfo.thumbprint != null) {
                return dfd.resolve(certInfo);
            }
            else {
                var object: IGReasonResponse = { handled: false, reason: "jres:32000482", type: EReasonType.serverError, operation: OperationsEnum.cert }; //RC 32000482 : Chybí otisk certifikátu.
                return dfd.reject(object);
            }
        }

    }

}